<script>
import { VDatePicker } from 'vuetify/lib/components'

export default {
  name: 'EDatePicker',
  extends: VDatePicker,
  props: {
    firstDayOfWeek: {
      type: Number,
      default: 1,
    },
    prevIcon: {
      type: String,
      default: 'icon-chevron-left',
    },
    nextIcon: {
      type: String,
      default: 'icon-chevron-right',
    },
    color: {
      type: String,
      default: 'primary',
    },
  },
  render() {
    return this.genPicker('e-date-picker v-picker--date')
  },
}
</script>
